import { combineReducers } from "redux";

import appointmentReducer from "./appointment";
import authReducer from "./auth";
import chargeEntryReducer from "./chargeEntry";
import appReducer from "./appReducer";
import dashboardReducer from "./dashboard";
import eraReducer from "./era";

export default combineReducers({
  appointment: appointmentReducer,
  auth: authReducer,
  chargeEntry: chargeEntryReducer,
  app: appReducer,
  dashboard: dashboardReducer,
  era: eraReducer,
});
